import { getLocale, translate } from "../localization";
export const BILLING_PLANS = [
  { purchaseType: "consumer_content", billingInterval: "month", get name() { return translate("Individual"); }, amount: 500,
    get description() { return translate("All web content for personal use."); } },
  { purchaseType: "consumer_content", billingInterval: "year", get name() { return translate("Individual"); }, amount: 2000,
    get description() { return translate("All web content for personal use."); } },
  { purchaseType: "classroom_license", billingInterval: "year", get name() { return translate("Classroom"); }, amount: 20000,
    get description() { return translate("Web content, educator analytics, and web student join codes."); } },
  { purchaseType: "site_license", billingInterval: "year", get name() { return translate("Site license"); }, amount: 120000,
    get description() { return translate("Unlimited web and VR access for your site, educator analytics, and student join codes."); } },
];

// Display copy only. Checkout availability and prices come from the account API.
export const PLAN_COMPARISON = [
  {
    purchaseType: "consumer_content", get name() { return translate("Individual"); }, get description() { return translate("A world of science to explore on your own."); },
    get heading() { return translate("Explore the library"); },
    get features() { return [
      translate("Full library of science experiences"),
      translate("Explore in your browser on laptops and desktops"),
    ]; },
  },
  {
    purchaseType: "classroom_license", get name() { return translate("Classroom"); }, get description() { return translate("Bring interactive science into your teaching."); },
    get heading() { return translate("Explore and teach"); },
    get features() { return [
      translate("Full web content library"),
      translate("Educator analytics"),
      translate("Student join codes for the web"),
      translate("Custom guide creation (beta)"),
    ]; },
  },
  {
    purchaseType: "site_license", get name() { return translate("Site license"); }, get description() { return translate("Bring web and VR to your entire site."); },
    get heading() { return translate("Teach across web + VR"); },
    get features() { return [
      translate("Everything in Classroom"),
      translate("Unlimited VR access across your site"),
      translate("Student join codes for web and VR"),
    ]; },
  },
];

export const formatPlanPrice = (amount, billingInterval, currency = "usd") =>
  `${new Intl.NumberFormat(getLocale(), { style: "currency", currency, minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(amount / 100)} / ${billingInterval === "year" ? translate("year") : billingInterval === "month" ? translate("month") : billingInterval}`;

export const getAccountPlanName = ({ subscriptionPurchaseType, roleName, subscriptionStatus }) => {
  if (subscriptionStatus === "trial") return translate("Educator trial");
  if (subscriptionStatus === "free" || !subscriptionStatus) return translate("Free account");
  if (subscriptionPurchaseType === "site_license" || String(roleName).toLowerCase() === "educatorsite") return translate("Site license");
  if (subscriptionPurchaseType === "classroom_license" || String(roleName).toLowerCase() === "educator") return translate("Classroom");
  if (subscriptionPurchaseType === "consumer_content" || String(roleName).toLowerCase() === "consumer") return translate("Individual");
  return translate("10k Science access");
};

// Older classroom checkouts did not include product or interval metadata.
export const matchesPurchasedPlan = (subscription, purchaseType, billingInterval) =>
  (subscription?.purchaseType || "classroom_license") === purchaseType &&
  (subscription?.billingInterval || "year") === billingInterval;
